import { render, staticRenderFns } from "./loginretail.vue?vue&type=template&id=686b2621"
import script from "./loginretail.vue?vue&type=script&lang=js"
export * from "./loginretail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686b2621')) {
      api.createRecord('686b2621', component.options)
    } else {
      api.reload('686b2621', component.options)
    }
    module.hot.accept("./loginretail.vue?vue&type=template&id=686b2621", function () {
      api.rerender('686b2621', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/loginretail.vue"
export default component.exports